import type { ReactNode } from 'react';

export const symbol_battery_android_question: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M100-300v-360 360Zm30 60q-38 0-64-26t-26-64v-300q0-38 26-64t64-26h515q15 0 22 9.5t7 20.5q0 11-8 20.5t-22 9.5H130q-13 0-21.5 8.5T100-630v300q0 13 8.5 21.5T130-300h567q14 0 22 9.5t8 20.5q0 11-7.5 20.5T697-240H130Zm695-56q11-11 11-26t-11-26q-11-11-26-11t-26 11q-11 11-11 26t11 26q11 11 26 11t26-11Zm-23-331q23 0 39.5 15t16.5 36q0 15-8.5 29.5T822-515q-21 19-31.5 35.5T780-434q0 10 4 17.5t15 7.5q11 0 18-7t9-18q3-18 12-29.5t22-23.5q24-22 36-45t12-46q0-41-30.5-69T802-675q-32 0-58.5 14.5T702-621q-5 8-2 17.5t13 13.5q9 4 18.5 0t16.5-12q10-11 24-18t30-7Z"
		/>
	</svg>
);
